import { render, staticRenderFns } from "./travaux-restants-confirmation.vue?vue&type=template&id=5a0a19ab&scoped=true"
import script from "./travaux-restants-confirmation.vue?vue&type=script&lang=ts"
export * from "./travaux-restants-confirmation.vue?vue&type=script&lang=ts"
import style0 from "./travaux-restants-confirmation.vue?vue&type=style&index=0&id=5a0a19ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a19ab",
  null
  
)

export default component.exports